import SpacingWrapper from '../atoms/SpacingWrapper';
import { COMMENT, DEFAULT } from 'conversations-message-history/constants/tileMessageUses';
import { useDeepLinkHighlight } from '../util/useDeepLinkHighlight';
import { Tile } from 'foundations-components/transitional/components/Tile';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const BORDER_COLORS = {
  [COMMENT]: 'fill-caution-hover',
  [DEFAULT]: 'border-core-subtle'
};
const BACKGROUND_COLORS = {
  [COMMENT]: 'fill-caution-subtle',
  [DEFAULT]: 'fill-surface-default'
};
const COLORS = {
  [COMMENT]: 'fill-accent-neutral-default',
  [DEFAULT]: 'text-core-default'
};
const TileMessageWrapper = styledWithTheme.div(({
  highlight,
  theme,
  use
}) => {
  const tileStyles = {
    backgroundColor: `${theme.color[BACKGROUND_COLORS[use]]} !important`,
    borderColor: `${theme.color[BORDER_COLORS[use]]} !important`,
    borderStyle: 'solid',
    borderWidth: theme.borderWidth['100'],
    color: theme.color[COLORS[use]]
  };
  if (highlight) {
    const borderColor = theme.color['border-interactive-default'];
    tileStyles.borderColor = `${borderColor} !important`;
    tileStyles.boxShadow = `0 0 0 1px ${borderColor}, 0 0 12px 0 ${borderColor}`;
  }
  return {
    '> *': tileStyles
  };
});
const TileMessage = ({
  children,
  positionDescriptors,
  use = DEFAULT,
  messageId
}) => {
  const shouldHighlight = useDeepLinkHighlight({
    messageId
  });
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_jsx(SpacingWrapper, {
    positionDescriptors: positionDescriptors,
    children: /*#__PURE__*/_jsx(TileMessageWrapper, {
      highlight: shouldHighlight,
      use: use,
      children: /*#__PURE__*/_jsx(Tile, {
        compact: true,
        "data-test-id": "tile-message-wrapper",
        inlineSize: "100%",
        padding: "0",
        children: children
      })
    })
  });
};
TileMessage.displayName = 'TileMessage';
export default TileMessage;